module.exports = __webpack_public_path__ + "img/cpzz7@2x.831c07af.png";